import {Card, CardActions, CardHeader} from "../components/layouts/card-components.tsx";
import {useTranslation} from "react-i18next";
import {useAppContext} from "../context/app-context.tsx";
import {Link} from "react-router-dom";
import {TableLoader} from "../components/table-loader.tsx";

export const Companies = () => {
    const {t} = useTranslation()
    const {network, networkStatus} = useAppContext()

    // The network arrives once, with the session, and this page only reads it.
    // It used to keep a `loading` state of its own that started true and was
    // cleared by a 300 ms setTimeout — an artificial delay in front of data
    // already in memory, and a spinner that never resolved at all when the
    // fetch failed, because `fetchNetwork` returns null on error and the guard
    // could not tell that from "not here yet".
    const loading = networkStatus === 'idle' || networkStatus === 'loading';
    const failed = networkStatus === 'error';
    const companies = network?.companies ?? [];

    return (
        <div className="z2 app_page_layout support_wide_screens">
            <div className="z2 app_page_toolbar">
                <div className="buttons">
                    <Link to={"add-company"} role="button" className="z2">
                        {t("nav.label.add_company")}
                    </Link>
                </div>
            </div>

            <div className={"app_page_body"}>
                <div style={{gridColumn: "span 4"}}>

                    <Card>
                        <CardHeader title={t("companies.title.companies")}/>

                        {loading && <TableLoader/>}

                        {failed && (
                            <p style={{textAlign: "center", margin: "2rem 0"}}>
                                {t("companies.load_failed", "The company list could not be loaded. Reload the page to try again.")}
                            </p>
                        )}

                        {!loading && !failed && companies.length === 0 && (
                            <p style={{textAlign: "center", margin: "2rem 0"}}>
                                {t("companies.empty", "This network has no companies yet.")}
                            </p>
                        )}

                        {!loading && !failed && companies.length > 0 && (
                            <div className="responsive_table">
                                <table>
                                    <thead>
                                    <tr>
                                        <th>{t("companies.header.company_name")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {companies.map((company) => (
                                        <tr key={company?.id}>
                                            <td>{company?.name}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <CardActions/>
                    </Card>
                </div>
            </div>


        </div>
    )
}
